import React from 'react';

interface BrandMarkProps {
  className?: string;
  imageClassName?: string;
  titleClassName?: string;
  labelClassName?: string;
  showLabel?: boolean;
  showTitle?: boolean;
}

const BrandMark: React.FC<BrandMarkProps> = ({
  className = '',
  imageClassName = 'h-10 w-10 rounded-2xl',
  titleClassName = 'text-sm font-bold uppercase tracking-[0.34em] text-neon-purple',
  labelClassName = 'min-w-0',
  showLabel = false,
  showTitle = true
}) => {
  return (
    <div className={`flex items-center gap-3 ${className}`.trim()}>
      <img
        src="/brand/logo-dopamind.png"
        alt="Logo do Dopamind"
        className={`shrink-0 object-contain ${imageClassName}`.trim()}
      />

      {(showTitle || showLabel) && (
        <div className={labelClassName}>
          {showTitle && <div className={titleClassName}>Dopamind</div>}
          {showLabel && (
            <div className="text-[10px] uppercase tracking-[0.28em] text-gray-500">
              R² Solutions Group
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BrandMark;
